import { type Quota } from "@muscat/types";
import { MessageInfo } from "../../../types/info";
import { QuotaAction } from "../../../types/actions";

export type State = {
	quotas: Quota[];
	loading: boolean;
	info: MessageInfo;
	version?: string;
	/**
	 * REP回収の有無
	 */
	isDemandForecastNeeded?: boolean;
};

export const initState: State = {
	quotas: [],
	loading: true,
	info: {
		message: "",
		isSuccess: true,
	},
};

export const reducer = (state: State, action: QuotaAction): State => {
	switch (action.type) {
		case "setQuotas":
			return {
				...state,
				loading: false,
				quotas: action.payload.quotas,
				isDemandForecastNeeded: action.payload.isDemandForecastNeeded,
				version: action.payload.version,
			};
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
